var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53511 4.76782C3.65788 2.66123 5.38624 1.01636 7.47698 1.01636H8.52284C10.6136 1.01636 12.3419 2.66123 12.4647 4.76782L12.6647 8.19889C12.6996 8.79816 12.2466 9.31252 11.6529 9.34779C11.0591 9.38302 10.5495 8.92579 10.5146 8.32652L10.3146 4.89546C10.2588 3.93792 9.47318 3.19026 8.52284 3.19026H7.47698C6.52664 3.19026 5.74101 3.93792 5.68521 4.89546L5.48524 8.32652C5.45031 8.92579 4.94068 9.38302 4.34694 9.34779C3.75321 9.31252 3.30021 8.79816 3.33514 8.19889L3.53511 4.76782Z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45036 14.107C1.53012 14.9367 2.19913 15.5299 3.03158 15.5734C4.05819 15.627 5.68435 15.683 7.99992 15.683C10.3155 15.683 11.9417 15.627 12.9683 15.5734C13.8007 15.5299 14.4697 14.9367 14.5495 14.107C14.6128 13.4484 14.6666 12.539 14.6666 11.3497C14.6666 10.1604 14.6128 9.25096 14.5495 8.59242C14.4697 7.76266 13.8007 7.16952 12.9683 7.12602C11.9417 7.07236 10.3155 7.01636 7.99992 7.01636C5.68435 7.01636 4.05819 7.07236 3.03158 7.12602C2.19913 7.16952 1.53012 7.76266 1.45036 8.59242C1.38705 9.25096 1.33325 10.1604 1.33325 11.3497C1.33325 12.539 1.38705 13.4484 1.45036 14.107Z",
    fill: "#CED4DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60451 11.5385C9.03711 11.3181 9.33341 10.8685 9.33341 10.3497C9.33341 9.61332 8.73645 9.01636 8.00008 9.01636C7.26371 9.01636 6.66675 9.61332 6.66675 10.3497C6.66675 10.8685 6.96305 11.3181 7.39565 11.5385L7.09995 13.0171C7.04098 13.3119 7.19315 13.6025 7.49045 13.6471C7.63038 13.6681 7.80025 13.683 8.00008 13.683C8.19991 13.683 8.36978 13.6681 8.50971 13.6471C8.80701 13.6025 8.95918 13.3119 8.90021 13.0171L8.60451 11.5385Z",
    fill: "#495057"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.8b609423d3a1a9ae8fd19d8412455411.svg";
export { ForwardRef as ReactComponent };